import React from 'react'

function ErrorMessage({handleClick,endPoint}) {

    return (
        <div className=" text-center align-center f-modal-alert">
            <div className="f-modal-icon f-modal-warning scaleWarning">
                <span className="f-modal-body pulseWarningIns"></span>
                <span className="f-modal-dot pulseWarningIns"></span>
            </div>
            <div>
                <h1>Quelque chose a mal tourné</h1>
                <p>Un erreur est survenue, veuillez réessayer plus tard</p>
            </div>
            <a className="modal__close"></a>
            <div className="modal__actions btn-warning btn" onClick={() => handleClick(endPoint)} ><a className="button warning" >Réessayer</a></div>
        </div>
    )
}

export default ErrorMessage
